import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';

const guides = [
  { 
    id: "driving-in-snow", 
    title: "How to drive in snow", 
    thumbnail: "https://img.youtube.com/vi/xN1WNOugM6A/maxresdefault.jpg",
    icon: "CloudSnow" 
  },
  { 
    id: "driving-in-fog", 
    title: "How to drive in Fog", 
    thumbnail: "https://img.youtube.com/vi/SKHvDfVHsWc/maxresdefault.jpg",
    icon: "AlignJustify" 
  },
  { 
    id: "driving-in-rain", 
    title: "How to drive in the rain", 
    thumbnail: "https://img.youtube.com/vi/CnBLsR5WsN0/maxresdefault.jpg",
    icon: "CloudRain" 
  },
  { 
    id: "driving-roundabouts", 
    title: "Driving Roundabouts", 
    thumbnail: "https://img.youtube.com/vi/16wi9uVq-SQ/maxresdefault.jpg",
    icon: "RotateCw" 
  },
  { 
    id: "driving-blizzard", 
    title: "How to drive in a blizzard", 
    thumbnail: "https://img.youtube.com/vi/ohX0YHr7Xjw/maxresdefault.jpg",
    icon: "Wind" 
  },
  { 
    id: "driving-on-ice", 
    title: "How to drive in ice", 
    thumbnail: "https://img.youtube.com/vi/rYpgyNlF6cM/maxresdefault.jpg",
    icon: "AlertOctagon" 
  }
];

const SafetyGuides = ({ delay }) => {
  return (
    <div className="mt-8 space-y-8">
      <motion.div 
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: delay }}
        className="text-center"
      >
        <h2 className="text-4xl font-black text-slate-900 uppercase tracking-tight">Safety guides</h2>
        <div className="w-24 h-2 bg-blue-600 mx-auto mt-4 rounded-full"></div>
      </motion.div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {guides.map((guide, index) => (
          <motion.div
            key={guide.id}
            initial={{ opacity: 0, scale: 0.95 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ delay: delay + (index * 0.1) }}
            className="group relative overflow-hidden rounded-3xl shadow-xl aspect-video bg-slate-900"
          >
            {/* YouTube Thumbnail Background */}
            <img 
              src={guide.thumbnail} 
              alt={guide.title}
              className="absolute inset-0 w-full h-full object-cover opacity-60 group-hover:scale-110 transition-transform duration-500"
            />
            
            <div className="absolute inset-0 bg-gradient-to-t from-slate-900 via-slate-900/40 to-transparent"></div>
            
            <div className="absolute inset-0 flex flex-col items-center justify-center p-6 text-center z-10">
              <div className="p-4 bg-blue-600/80 backdrop-blur-md rounded-full mb-4 group-hover:scale-110 transition-transform shadow-lg">
                <SafeIcon name={guide.icon} className="text-4xl text-white" />
              </div>
              <h3 className="text-xl font-black text-white uppercase leading-tight drop-shadow-lg mb-4">
                {guide.title}
              </h3>
              
              <Link 
                to={`/safety/${guide.id}`}
                className="py-3 px-6 bg-white text-slate-900 rounded-xl font-black text-sm uppercase tracking-widest hover:bg-blue-600 hover:text-white transition-all shadow-xl"
              >
                Watch Video
              </Link>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default SafetyGuides;